import styled from 'styled-components'
import colors from '../../../configuration/colors'

export const ModalStyles = styled.div`
  display: flex;
  flex-direction: column;
  padding: 41px 41px 26.5px 41px;

  .no-animate {
    animation: none !important;
  }
  
  .header {
    height: 38px;
    width: 100%;
    color: #444444;
    font-size: 16px;
    font-weight: 300;
    letter-spacing: 0;
    line-height: 19px;
    text-align: center;
    margin-bottom: 18px;
    font-family: 'Lato', sans-serif;
  }
  
  input {
    border: .5px solid #bbbbbb;
    background-color: white;
    width: 100%;
    margin-bottom: 5px;
  }

  .toggle-password {
    top: 44% !important;
    right: 15px !important;
    z-index: 99;
  }

  .__react_component_tooltip {
    width: 179px;
  }
  
  .input-label {
    height: 16px;
    width: 218px;
    color: #666666;
    font-size: 11px;
    letter-spacing: 0;
    font-family: 'Lato', sans-serif;
    line-height: 16px;
    margin: 10px 0 2px 0;
  }
  
  .error {
    height: 16px;
    color: #DC143C;
    font-size: 11px;
    letter-spacing: 0;
    font-family: 'Lato', sans-serif;
    line-height: 16px;
    font-weight: bold;
    margin-bottom: 10px;
  }
  
  .helper {
    height: 13px;
    width: 125px;
    color: #666666;
    font-size: 11px;
    font-weight: 300;
    letter-spacing: 0;
    line-height: 13px;
    font-family: 'Lato', sans-serif;
  }
  
  .policy {
    height: 60px;
    width: 100%;
    color: #666666;
    font-size: 13px;
    font-weight: 300;
    letter-spacing: 0;
    line-height: 16px;
    text-align: center;
    margin-top: 12px;
    font-family: 'Lato', sans-serif;
  }
  
  button {
    height: 45px;
    width: 180px;
    border-radius: 40px;
    background-color: #CCCCCC;
    border: none;
    margin: 0 auto;
    display: block;
    text-align: center;
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 19px;
  }
  
  .center {
    display: block;
    margin: auto;
    text-align: center;
  }
  
  .success-mark {
    background-color: ${colors.jadeLite};
    border-radius: 100%;
    margin-bottom: 28px;
    height: 56px;
    width: 56px;
    padding: 13px;
  }
  
  .error-heading {
    color: #263746;
    font-size: 20px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 24px;
    font-family: 'Lato', sans-serif;
    text-align: center;
  }
  
  .error-text {
    color: #444444;
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 20.8px;
    font-family: 'Lato', sans-serif;
    text-align: center;
    
    a {
      color: ${colors.cobalt};
    }
  }

  .link {
    color: ${colors.cobalt};
    font-weight: 400;
    cursor: pointer;
  }
  
  .line {
    box-sizing: border-box;
    width: 472px;
    border: .5px solid #ECECEC;
    box-shadow: 0 0 30px 0 rgba(0,0,0,0.07);
    position: absolute;
    right: 0;
  }
`

export const LinkedAccount = styled.div`
  background-color: #F5F5F5;
  width: 100%;
  margin-bottom: 26.5px;
  text-align: center;
  display: inline-block;
  height: 45px;
  cursor: pointer;
  
  p {
    height: 20.8px;
    width: 100%;
    color: #444444;
    font-size: 16px;
    font-weight: 300;
    letter-spacing: 0;
    line-height: 15px;
    text-align: center;
  }

  .link {
    color: ${colors.cobalt};
    font-weight: 500;
  }
`

export const PolicyModalStyles = styled.div`
  display: flex;
  flex-direction: column;

  .policy-header {
    margin-left: 35px;
    display: flex;

    .close-button {
      position: relative;
      left: 540px;
      bottom: 20px;
      color: #9d9b9b;
      cursor: pointer;

      &:hover {
        filter: brightness(0.5) sepia(0) hue-rotate(100deg) saturate(6);
      }
    }
  }

  .container-body {
    height: 575px;
    overflow-y: scroll;
    background-color: #F5F5F5;
  }

  .policy-list-item {
    background-color: #F5F5F5 !important;
  }

  .policies-container li {
    background-color: #F5F5F5 !important;
  }

  .policies-container {
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
  }
`
